import type { SubscriptionTier } from "@/lib/retention";

/**
 * Single source of truth for monthly credit limits per subscription tier.
 * All components MUST import from here — never hardcode limits.
 */
export const TIER_LIMITS: Record<SubscriptionTier, number> = {
  free: 3,
  pro: 30,
  business: 120,
  enterprise: 999999,
};

/** Get the monthly credit limit for a tier string (defaults to free). */
export const getMonthlyLimit = (tier: string): number => {
  return TIER_LIMITS[tier as SubscriptionTier] ?? TIER_LIMITS.free;
};

/** Calculate remaining credits (monthly remaining + bonus). */
/** Calculate remaining credits — wallet model: bonus_generations IS the balance. */
export const calculateRemainingCredits = (
  _tier: string,
  _designsThisMonth: number,
  bonusGenerations: number,
): number => {
  return bonusGenerations;
};
